import algoliasearch from "algoliasearch/lite";
import config from "../config";
import { buildAlgoliaQuery, extractQueryParams, JobCategory, JobPreferences, RequestOptions } from "@pga/algolia-utils";
import { isEmpty } from "lodash";

export const PER_PAGE_MAX = 1000;

export const searchClient = algoliasearch(config.algoliaAppId, config.algoliaApiKey).initIndex(config.algoliaJobsIndex);

type Params = RequestOptions & {
  categories?: JobCategory[];
  preferences?: JobPreferences;
};

export default function search<T>(query: string, { preferences, categories = [], filters, ...params }: Params) {
  const queryParams =
    isEmpty(preferences) && isEmpty(categories) ? { excludeProOnly: false } : extractQueryParams(preferences, categories);

  const { filters: defaultFilters, ...defaultParams } =
    buildAlgoliaQuery({
      queryParams,
      additionalAttributes: [
        "hide_compensation_from_job_board",
        "pay_schedule",
        "base_compensation_max",
        "employment_type",
        "additional_income",
        "applicant_group",
      ],
    }) || {};

  const combinedFilters = ((f: string) => (isEmpty(f) ? {} : { filters: f }))(
    [defaultFilters, filters].filter((f) => !isEmpty(f)).join(" AND ")
  );

  const combinedParams = { attributesToHighlight: [], ...defaultParams, ...combinedFilters, ...params };

  return searchClient.search<T>(query, combinedParams);
}
